<template>
  <div>
    <div
      :class="$style['date-time-picker']"
      @click="onClick"
    >
      <div
        :class="$style['input-wrapper']"
        class="center-horizontal"
      >
        <div :class="$style['calendar-wrapper']">
          <ds-calendar-icon />
        </div>
        <div>
          {{ date[0] | moment(displayDateFormat) }} - {{ date[1] | moment(displayDateFormat) }}
        </div>
      </div>
      <el-date-picker
        ref="picker"
        v-model="date"
        :picker-options="options"
        :type="type"
        @change="dateChange"
        @blur="onBlur"
      />
      <div :class="$style['arrow-wrapper']">
        <ds-arrow-icon
          v-if="open"
          :default-rotation="270"
        />
        <ds-arrow-icon
          v-else
          :default-rotation="90"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DatePicker } from "element-ui";
import DsCalendarIcon from "../icons/ds-calendar-icon";
import DsArrowIcon from "../icons/ds-arrow-icon";

export default {
  name: "DsDatetimePicker",
  components: {
    [DatePicker.name]: DatePicker,
    DsCalendarIcon,
    DsArrowIcon
  },
  props: {
    startDate: {
      type: Date,
      default: () =>
        moment()
          .startOf("day")
          .toDate()
    },
    endDate: {
      type: Date,
      default: () =>
        moment()
          .endOf("day")
          .toDate()
    },
    displayDateFormat: {
      type: String,
      default: "YYYY-MM-DD-HH:mm:ss"
    },
    type: {
      type: String,
      default: "datetimerange"
    }
  },
  data() {
    return {
      open: false,
      date: [this.startDate, this.endDate],
      options: {
        shortcuts: [
          {
            text: "Ostatni tydzień",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Ostatni miesiąc",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Ostatnie 3 miesiące",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  watch: {
    startDate: function(value) {
      this.date = [value, this.endDate];
    },
    endDate: function(value) {
      this.date = [this.startDate, value];
    }
  },
  methods: {
    dateChange: function(newData) {
      this.$emit("dateChanged", newData);
    },
    closePicker: function() {
      this.$refs.picker.blur();
      this.open = false;
    },
    openPicker: function() {
      this.$refs.picker.focus();
      this.open = true;
    },
    onBlur: function() {
      this.open = false;
    },
    onClick: function() {
      if (!this.open) {
        this.openPicker();
      } else {
        this.closePicker();
      }
    },
    mouseLeave: function() {
      this.closePicker();
    }
  }
};
</script>
<style lang="scss">
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";
.el-time-panel.el-popper {
  display: none !important;
  > div {
    display: flex;
    align-items: center;
    height: 100%;
  }
}
.el-input__inner {
  font-weight: 600 !important;
}
.el-date-editor {
  position: absolute !important;
  left: 0px;
  height: 0px !important;
  border: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}
.el-date-editor * {
  display: none !important;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: $light-blue-color;
}
.el-picker-panel__sidebar {
  width: 170px !important;
}
.el-picker-panel__body {
  margin-left: 170px !important;
}
.el-picker-panel {
  @include mobile() {
    max-width: 100vw;
    overflow: scroll;
  }
}
</style>

<style lang="scss" scoped>
@import "~element-ui/lib/theme-chalk/date-picker.css";
@import "~element-ui/lib/theme-chalk/icon.css";
@import "~element-ui/lib/theme-chalk/spinner.css";
@import "~element-ui/lib/theme-chalk/button.css";
</style>

<style lang="scss" module>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

.date-time-picker {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 40px;
}
.arrow-wrapper {
  padding-left: 15px;
  padding-right: 10px;
  // @include mobile() {
  //   display: none;
  // }
}
.calendar-wrapper {
  margin-left: 8px;
  padding-right: 0px;
  margin-bottom: 2px;
  svg {
    margin-right: 10px;
  }
}
.input-wrapper {
  height: 100%;
  > * {
    display: flex;
    align-items: center;
    height: 100%;
  }
}
</style>
<style>
.el-time-spinner__item {
  background-color: initial !important;
}
.el-date-range-picker {
  margin-top: 25px !important;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-datetime-picker.vue